export default {
  primary: '#4caf50',
  secondary: '#03A9F4',
  tertiary: '#607D8B',
  forty: '#D50000',
  fifty: '#FFFF00',
  sixty: '#0336FF',
  accent: '#82B1FF',
  error: '#fd77a4',
  info: '#419ef9',
  success: '#00bf9a',
  warning: '#ff9f89'
}